import state from './state'

export default {
    setFormId(state, id) {
        state.formId = id
    },
    setForm(state, form) {
        state.form = form
    }
}
